import {
    getAxios,
    formDataToRequestParams
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberWalletCharge(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/bobstore/order/check-amount/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function paymentWithTokens(data = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/bobstore/order/charge-wallet/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberWalletCharge.js